import { Injectable } from '@angular/core';
import { MissingTranslationHandler, TranslateCompiler, TranslateParser, TranslateService, TranslateStore } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Language, LocalizationService, LocalizationSettings } from './localization.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Utilities_LocalizationService } from './Utilities.localization.service';
import { ShipTheory_LocalizationService } from './ShipTheory.localization.service';
import { PrintNode_LocalizationService } from './PrintNode.localization.service';
import { ProShip_LocalizationService } from './ProShip.localization.service';
import { EasyPost_LocalizationService } from './EasyPost.localization.service';

@Injectable({
  providedIn: 'root'
})
export class Manifesting_LocalizationService
  extends LocalizationService<{  }> {

  public Manifesting: Manifesting_LocalizationService = this;

  public override get settings(): LocalizationSettings {
    return {"default":"","languages":[]}
  }
  
  private _referencedServices: LocalizationService<any>[] = [];

  constructor(
    httpClient: HttpClient,
    compiler: TranslateCompiler,
    parser: TranslateParser,
    missingHandler: MissingTranslationHandler,
    public Utilities: Utilities_LocalizationService,
    public ShipTheory: ShipTheory_LocalizationService,
    public PrintNode: PrintNode_LocalizationService,
    public ProShip: ProShip_LocalizationService,
    public EasyPost: EasyPost_LocalizationService
    ) {
    super(
      new TranslateService(
        new TranslateStore(),
        new TranslateHttpLoader(httpClient, '../assets/i18n/Manifesting/', '.json'),
        compiler,
        parser,
        missingHandler,
        true,
        true,
        false,
        ''));

    this._referencedServices.push(this.Utilities);

    this._referencedServices.push(this.ShipTheory);

    this._referencedServices.push(this.PrintNode);

    this._referencedServices.push(this.ProShip);

    this._referencedServices.push(this.EasyPost);
    
    this.initialize();

  }

  public override setLanguage(lang: Language): void{
    super.setLanguage(lang);
  
    for (let i of this._referencedServices){
      i.setLanguage(lang);
    }
  }
}